import React from 'react'
import { Grid, Button, Box } from '@the-platform-group/component-library'
import { ArrowForward as ArrowForwardIcon } from '@the-platform-group/component-library/Icons'
import { usePeopleMergeContext } from '../../contexts/PeopleMergeContext'
import ProfileSummary from './ProfileSummary'
import SearchInput from '../SearchInput'

const SearchInputs = ({ disabled }) => {
  const { mergeData } = usePeopleMergeContext()
  const {
    sourceId,
    targetId,
    handleSourceIdChange,
    handleTargetIdChange,
    handleSearch,
    isLoading,
    sourcePerson,
    targetPerson,
    sourceError,
    targetError,
  } = mergeData
  return (
    <Grid item container alignItems="flex-start" sx={{ p: 3, backgroundColor: 'grey.50' }}>
      <SearchInput
        label="Platform UUID (source)"
        value={sourceId}
        onChange={handleSourceIdChange}
        disabled={isLoading || disabled}
        error={sourceError}
        helperText={sourceError}
      >
        {sourcePerson && (
          <Grid item>
            <ProfileSummary person={sourcePerson} />
          </Grid>
        )}
      </SearchInput>

      <Grid item xs={2}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <ArrowForwardIcon
            color="primary"
            sx={{
              fontSize: 48,
            }}
          />
        </Box>
      </Grid>

      <SearchInput
        label="FactSet UUID (target)"
        value={targetId}
        onChange={handleTargetIdChange}
        disabled={isLoading || disabled}
        error={targetError}
        helperText={targetError}
      >
        {targetPerson && (
          <Grid item>
            <ProfileSummary person={targetPerson} />
          </Grid>
        )}
      </SearchInput>

      <Grid item xs={12}>
        <Box display="flex" justifyContent="center">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleSearch}
            disabled={!sourceId || !targetId || isLoading || disabled}
            size="large"
          >
            {isLoading ? 'Loading...' : 'Search & Preview'}
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}

export default SearchInputs
